import { Button, Tooltip } from "@mui/material";
import {
  type FieldEntry,
  schemaDefaultsToApply,
} from "../../../../SystemSettings.utils";

interface SystemSettingsGroupResetProps {
  fields: FieldEntry[];
  form: any;
}

export default function SystemSettingsGroupReset({
  fields,
  form,
}: SystemSettingsGroupResetProps) {
  return (
    <form.Subscribe
      selector={(state: { values?: { [key: string]: unknown } }) =>
        schemaDefaultsToApply(fields, state.values).length === 0
      }
      children={(hidden: boolean) =>
        hidden ? null : (
          <Tooltip
            arrow
            placement="top"
            disableInteractive
            describeChild
            title="Reset this section to its defaults"
          >
            <Button
              type="button"
              size="small"
              className="ml-auto"
              data-test-id="system-settings__group-reset"
              onClick={() => {
                for (const [key, value] of schemaDefaultsToApply(
                  fields,
                  form.state.values
                )) {
                  form.setFieldValue(key, value);
                }
              }}
            >
              Reset
            </Button>
          </Tooltip>
        )
      }
    />
  );
}
